import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../core'
import * as engagementCharters from '../../engagement-charters'

export const RESOURCE = {
  payload: {
    description: 'The generated engagement charter for a project.',
    dimension: engagementCharters.RESOURCE.payload,
    level: 0,
    name: 'Engagement Charter',
    partialId: PartialId.Standard.create('engagement_charter'),
  },
  type: core.quiver.Resource.Type.DmsEntity,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEntity>

export const MODEL_ID = core.dms.models.Entity.Id.from({
  context: core.dms.models.Entity.Id.Context.from(RESOURCE.payload.dimension),
  partialId: RESOURCE.payload.partialId,
})
